export default __webpack_public_path__ + "static/media/active-workspace-icon.e59b8fa7.svg";